import _ from 'lodash';
import cookies from 'js-cookie';

export default function myRgsCleanupCookies () {
	_.each(cookies.get(), (value, name) => {
		if (/^Rgs\.My\./.test(name) || /^Rgs\.Calcs\.Osago2\./.test(name)) {
			cookies.remove(name, { path: '/' });
		}
	});
}


